import { React, useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Alert,
  FormControl
} from "@mui/material";
import { Formik, Field } from "formik";
import * as yup from "yup";
import axios from "axios";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageTitles from "../components/Layout/PageTitles";
import LoadingButton from "@mui/lab/LoadingButton";
import { API_URL } from "../../src/App";

const RegisterNewAdminUser = ({ setOpen, refresh, setRefresh }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [alert, setAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [reset, setReset] = useState(false);
  const [updateOrgs, setUpdateOrgs] = useState(0);
  const [allUsernames, setAllUsernames] = useState([]);
  const [allEmails, setAllEmails] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [resetKey2, setResetKey2] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [unBtnLoading, setUnBtnLoading] = useState(false);

  const scrollElement = document.getElementById("RegUserContainer");

  const accountStateArray = [{'stateid': 1, 'statename':'Inactive'}, {'stateid': 2, 'statename':'Active'} ]

  useEffect(() => {

    axios.get(`${API_URL}/admin_users`).then((res) => {
      const users = res.data.admin_users.map((user) => user.username);
      const emails = res.data.admin_users.map((user) => user.email);
      setAllEmails(emails);
      setAllUsernames(users);
    });

  }, []);

  const makePassword = (setFieldValue) => {
    setBtnLoading(true);
    axios
      .get(`${API_URL}/get_password`)
      .then((res) => {
        setFieldValue("password", res.data.password);
        setBtnLoading(false);
      })
      .catch((error) => {
      
        setBtnLoading(false);
      });
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    inputIPAddress: "",
    inputNoIP: true,
    inputState: 2,
    inputWelcome: false,
  };

  const userSchema = yup.object().shape({
    firstName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    lastName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Required")
      .transform((value) => value.toLowerCase())
      .notOneOf(
        allEmails.map((email) => email.toLowerCase()),
        "Email already exists"
      ),
    username: yup
      .string()
      .min(5, "Too Short!")
      .max(10, "Too Long!")
      .required("Required")
      .notOneOf(allUsernames, "Username already exists")
      .matches(
        /^[a-z0-9]+$/,
        "Username must contain only lowercase letters and no spaces"
      ),
    password: yup
      .string()
      .min(8, "Too Short!")
      .max(35, "Too Long!")
      .test(
        "passwordCheckbox",
        'Enter a password or select "Create password" below',
        function (password) {
          const { inputWelcome } = this.parent;
          // Fail when both have values or neither have values
          return !((inputWelcome && password) || (!inputWelcome && !password));
        }
      ),
    inputIPAddress: yup
      .string()
      .matches(
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:, ?(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))*$|^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}($|,([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4})+$/,
        "Invalid IP address. If you wish to add more than one IP address, then separate the IP addresses with a comma and no spaces"
      )
      .test(
        "inputIPAddressCheckbox",
        "Enter an IP address or select the checkbox below",
        function (inputIPAddress) {
          const { inputNoIP } = this.parent;
          return !(
            (inputNoIP && inputIPAddress) ||
            (!inputNoIP && !inputIPAddress)
          );
        }
      ),
  });

  const myHandleReset = () => {
    setResetKey(resetKey + 1);
  };

  const handleFormSubmit = (values, { resetForm }) => {
    if (setOpen) {
      setOpen(false);
      setRefresh(refresh + 1);
    }

    axios
      .post(`${API_URL}/register_admin_user`,  {values: values})
      .then((res) => {
        if (res.data.message === "Admin User added") {
          setAlertContent("Admin User has been added successfully");
          setAlert(true);
          setReset(true);
          setUpdateOrgs(updateOrgs + 1);
          scrollElement.scrollIntoView({ block: "start", behavior: "smooth" });
          resetForm({ values: initialValues });
          setResetKey(resetKey + 1);
          setResetKey2(resetKey2 + 1);
        }
      })
      .catch((error) => {
        setErrorAlert(true);
        setAlertContent("There was an error when adding user!");
      });
  };

    return (
      <Box m="20px" id="RegUserContainer">
        <div
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <PageTitles title={"Register New Admin User"} />
        </div>
        <br />
        {alert ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="success"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        {errorAlert ? (
          <Alert
            onClose={() => {
              setErrorAlert(false);
            }}
            severity="error"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        <br />
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={userSchema}
        >
          {({
            values,
            errors,
            touched,
            resetForm,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            dirty,
          }) => (
            <form onSubmit={handleSubmit} onReset={resetForm}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <Typography sx={{ gridColumn: "span 4" }}>
                  User details
                </Typography>
                <TextField
                  autoFocus={true}
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstName}
                  name="firstName"
                  error={!!touched.firstName && !!errors.firstName}
                  helperText={touched.firstName && errors.firstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastName}
                  name="lastName"
                  error={!!touched.lastName && !!errors.lastName}
                  helperText={touched.lastName && errors.lastName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Username"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.username}
                  name="username"
                  error={!!touched.username && !!errors.username}
                  helperText={touched.username && errors.username}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  disabled={values.inputWelcome}
                  variant="filled"
                  type="text"
                  label="Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={!values.inputWelcome ? values.password : ""}
                  name="password"
                  error={!!touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                  sx={{ gridColumn: "span 2" }}
                />
                <LoadingButton
                  disabled={values.inputWelcome}
                  variant="contained"
                  size="medium"
                  loading={btnLoading}
                  sx={{
                    m: "10px",
                    backgroundColor: "#2196f3",
                    "&:hover": { backgroundColor: "#0d47a1" },
                  }}
                  onClick={() => {
                    makePassword(setFieldValue);
                  }}
                >
                  create a new password
                </LoadingButton>
                

                <TextField
                  fullWidth
                  disabled={values.inputNoIP}
                  variant="filled"
                  type="text"
                  label="IP address(es)"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={!values.inputNoIP ? values.inputIPAddress : ""}
                  name="inputIPAddress"
                  error={!!touched.inputIPAddress && !!errors.inputIPAddress}
                  helperText={touched.inputIPAddress && errors.inputIPAddress}
                  sx={{ gridColumn: "span 2" }}
                />
                <Field name="inputState" sx={{ gridColumn: "span 2" }}>
                  {({ field }) => (
                    <FormControl>
                      {accountStateArray.length > 0 ? (
                        <TextField
                          select
                          label="State"
                          sx={{ gridColumn: "span 2" }}
                          id="inputState"
                          {...field}
                          onChange={handleChange}
                        >
                          {accountStateArray.map(({ stateid, statename }) => (
                            <MenuItem key={stateid} value={stateid}>
                              {statename}
                            </MenuItem>
                          ))}
                        </TextField>
                      ) : (
                        <TextField
                          disabled
                          id="inputState"
                          fullWidth
                          required
                          label="State"
                          value={"Active"}
                        ></TextField>
                      )}
                    </FormControl>
                  )}
                </Field>

                <FormControlLabel
                  control={
                    <Checkbox
                      name="inputNoIP"
                      checked={values.inputNoIP}
                      onChange={() => {
                        setFieldValue("inputIPAddress", "").then(() => {
                          setFieldValue("inputNoIP", !values.inputNoIP);
                        });
                      }}
                      sx={{ mr: "20px" }}
                    />
                  }
                  label="Leave blank to set at first use.
                Account not tied to single IP address"
                  labelPlacement="start"
                  sx={{ gridColumn: "span 2" }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="inputWelcome"
                      checked={values.inputWelcome}
                      onChange={() => {
                        setFieldValue("password", "").then(() => {
                          setFieldValue("inputWelcome", !values.inputWelcome);
                        });
                      }}
                      sx={{ mr: "20px" }}
                    />
                  }
                  label="Create password and send welcome e-mail?"
                  labelPlacement="start"
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Create New Admin User
                </Button>
                <Button
                  type="reset"
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    myHandleReset(values);
                  }}
                >
                  Reset
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
};

export default RegisterNewAdminUser;
